import { Field, PageLinkButton, TableCell, TablePage } from '@contember/admin'
import * as React from 'react'
import { EditButton } from '../components'

export const TapsterListPage = (
	<TablePage
		pageName="tapsterList"
		entities="Tapster[site.slug = $site]"
		orderBy="publishedAt desc"
		rendererProps={{
			title: 'Tapsters',
			actions: (
				<>
					<PageLinkButton to="tapstersPage">Edit the Tapsters page</PageLinkButton>
					<PageLinkButton to="tapsterCreate">Add a new tapster</PageLinkButton>
				</>
			),
		}}
	>
		<TableCell>
			<Field field="name" />
		</TableCell>
		<TableCell>
			<Field field="subtitle" />
		</TableCell>
		<TableCell>
			<div style={{ color: '#444', fontSize: '11px' }}>
				<Field
					field="publishedAt"
					format={val => {
						return val ? 'Published on ' + new Date(val as string).toLocaleDateString() : 'Not published'
					}}
				/>
			</div>
		</TableCell>
		<TableCell shrunk>
			<EditButton pageName="tapsterEdit" />
		</TableCell>
	</TablePage>
)
